<template>
  <div class="section-card h-100 mb-0 slide-up-element">
    <div class="section-header-interactive d-flex align-items-center mb-3">
      <div class="header-icon-badge  mr-2" :class="headerIconClass">
        <font-awesome-icon :icon="headerIcon" size="xl" />
      </div>
      <slot name="header">
        <h6 class="m-0 font-weight-bold text-dark">{{headerTitle}}</h6>
      </slot>
    </div>
    <div class="container-grid">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionCard',
  props: {
    headerTitle: {
      type: String
    },
    headerIcon: {
      type: Array,
      required: true
    },
    headerIconClass: {
      type: String,
      required: false,
      default: 'bg-warning-blue'
    }
  }
}
</script>

<style scoped>
.section-card {
  background: rgba(255, 255, 255, 0.95);
  /* backdrop-filter: blur(12px); */
  border: 1px solid #b8cde8;
  border-radius: 18px;
  padding: 15px;
  box-shadow: 0 10px 30px rgba(22, 61, 125, 0.05);
}

.section-header-interactive {
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f1f5f9;
}


.container-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;
  align-items: flex-start;
  justify-items: center;
}

.header-icon-badge {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
}

.bg-warning-orange {
  background: #fef3c7;
  color: #d97706;
  box-shadow: 0 0 10px rgba(245, 158, 11, 0.2);
}

.bg-warning-blue {
  background: #e8f0fe;
  color: #163D7D;
  box-shadow: 0 0 10px rgba(11, 159, 245, 0.2);
}

.slide-up-element {
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>